import { useSyncExternalStore } from "react"

const subscribers = new Set<() => void>()
let interval: ReturnType<typeof globalThis.setInterval> | undefined
let now = Date.now()

function notifySubscribers(): void {
  now = Date.now()
  for (const subscriber of subscribers) subscriber()
}

function subscribe(subscriber: () => void): () => void {
  subscribers.add(subscriber)
  if (!interval) interval = globalThis.setInterval(notifySubscribers, 1_000)

  return () => {
    subscribers.delete(subscriber)
    if (subscribers.size === 0 && interval) {
      globalThis.clearInterval(interval)
      interval = undefined
    }
  }
}

function getSnapshot(): number {
  return now
}

export function useGuildEventNow(): number {
  return useSyncExternalStore(subscribe, getSnapshot, Date.now)
}
